// src/constants/projectTypes.js
//
// Project "type" = the purpose / lifecycle phase of the work (distinct from
// product/tool and persona/actor). ONE source of truth for the key → label
// map — the creation selector, portfolio badge, dashboard header badge, and
// the portfolio filter all read this. Adding a type later = one entry here +
// one CHECK value in the DB (migration) + the backend key set.

export const PROJECT_TYPES = [
  { key: "exploration_planning",  label: "Exploration & Planning" },
  { key: "reclamation_closure",   label: "Reclamation & Closure" },
  { key: "production_monitoring", label: "Production & Monitoring" },
  { key: "due_diligence",         label: "Due Diligence", tooltip: "M&A / Due Diligence" },
  // room to grow: development, regulatory_compliance
];

export const PROJECT_TYPE_KEYS = PROJECT_TYPES.map((t) => t.key);

const BY_KEY = new Map(PROJECT_TYPES.map((t) => [t.key, t]));

export const UNSPECIFIED_LABEL = "Unspecified";

// Badge/selector label for a stored key. NULL/unknown → "Unspecified".
export function projectTypeLabel(key) {
  return BY_KEY.get(key)?.label ?? UNSPECIFIED_LABEL;
}

// Hover/title text — the fuller phrasing where it differs from the badge label.
export function projectTypeTooltip(key) {
  const t = BY_KEY.get(key);
  return t ? (t.tooltip ?? t.label) : UNSPECIFIED_LABEL;
}
